var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "pram",
          attrs: { model: _vm.pram, rules: _vm.rules, "label-width": "150px" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "管理员手机号", prop: "account" } },
            [
              _c("el-input", {
                attrs: { placeholder: "管理员手机号" },
                model: {
                  value: _vm.pram.account,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "account", $$v)
                  },
                  expression: "pram.account",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "管理员密码", prop: "password" } },
            [
              _c("el-input", {
                attrs: { placeholder: "管理员密码", clearable: "" },
                on: { input: _vm.handlerPwdInput, clear: _vm.handlerPwdInput },
                model: {
                  value: _vm.pram.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "password", $$v)
                  },
                  expression: "pram.password",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "pwd-hint" }, [
                _vm._v(
                  "8-20位，必须有字母+数字，可配合常见符号如 . _ - ! @ # $ &"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.pram.password
            ? _c(
                "el-form-item",
                { attrs: { label: "确认密码", prop: "repwd" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "确认密码", clearable: "" },
                    model: {
                      value: _vm.pram.repwd,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "repwd", $$v)
                      },
                      expression: "pram.repwd",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "管理员姓名", prop: "realName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "管理员姓名" },
                model: {
                  value: _vm.pram.realName,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "realName", $$v)
                  },
                  expression: "pram.realName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "角色", prop: "roleIds" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择角色",
                    clearable: "",
                    multiple: "",
                  },
                  model: {
                    value: _vm.pram.roleIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "roleIds", $$v)
                    },
                    expression: "pram.roleIds",
                  },
                },
                _vm._l(_vm.roleList.recordList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.roleName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c("el-switch", {
                attrs: { "active-value": true, "inactive-value": false },
                model: {
                  value: _vm.pram.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "status", $$v)
                  },
                  expression: "pram.status",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["system:admin:update", "system:admin:save"],
                      expression: "['system:admin:update','system:admin:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerSubmit("pram")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.isCreate === 0 ? "確定" : "更新"))]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }